import React from 'react';
import { Input } from 'antd';
import { TextAreaProps } from 'antd/lib/input';

const { TextArea } = Input;

interface OwnProps {
  showCharacterCount: boolean;
  value?: string;
  onChange?: (value?: string) => void;
}

type Props = OwnProps & TextAreaProps;

const TextAreaWithCharacterCount = React.forwardRef<React.ElementRef<typeof TextArea>, Props>(
  ({ showCharacterCount, value, onChange, ...rest }, ref) => {
    const triggerChange = (changedValue?: string) => {
      if (onChange) {
        onChange(changedValue);
      }
    };

    const onValueChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      triggerChange(e.target.value);
    };

    const { maxLength } = rest;

    return (
      <>
        <TextArea {...rest} value={value} onChange={onValueChange} ref={ref} />
        {showCharacterCount && (
          <div style={{ textAlign: 'end', fontSize: '12px', lineHeight: '10px' }}>
            <span>{value ? value.length : 0}</span>
            {maxLength && <span> / {maxLength}</span>}
            <span> karakters</span>
          </div>
        )}
      </>
    );
  }
);

export { TextAreaWithCharacterCount };
